/**
 * Pause-on-hover for CSS-animated marquees, with debounce so a quick mouse
 * fly-by doesn't interrupt the animation.
 *
 * Markup contract: a track element with [data-marquee-track]. Optionally set
 * data-marquee-pause-delay="<ms>" to override the default debounce window.
 * The track gets the .is-paused class when paused; CSS turns that into
 * `animation-play-state: paused`.
 */
(function () {
  const DEFAULT_PAUSE_DELAY = 600;

  function bind(track) {
    if (track.dataset.marqueeBound === '1') return;
    track.dataset.marqueeBound = '1';

    const delay = parseInt(track.dataset.marqueePauseDelay, 10) || DEFAULT_PAUSE_DELAY;
    let timer = null;

    function clearPending() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    track.addEventListener('mouseenter', function () {
      clearPending();
      timer = setTimeout(function () {
        track.classList.add('is-paused');
        timer = null;
      }, delay);
    });

    track.addEventListener('mouseleave', function () {
      clearPending();
      track.classList.remove('is-paused');
    });

    // Touch: don't pause; tapping should not freeze the marquee.
  }

  function init() {
    document.querySelectorAll('[data-marquee-track]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind any new tracks when sections re-render in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
